"use strict";

exports.__esModule = true;
exports.ListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BPMenuItem = (0, _styledComponents["default"])(_core.MenuItem).withConfig({
  displayName: "ListItem__BPMenuItem",
  componentId: "sc-p0x1af-0"
})(["display:flex;align-items:", ";.", "{margin-top:", ";"], function (props) {
  return props.hasdescription ? "flex-start" : "center";
}, _core.Classes.iconClass(_icons.IconNames.TICK), function (props) {
  return props.hasdescription ? "6px" : 0;
});
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "ListItem__FlexContainer",
  componentId: "sc-p0x1af-1"
})(["display:flex;flex-direction:column;justify-content:center;width:100%;height:", "px;.bp6-text-overflow-ellipsis{margin-top:2px;&:empty{margin:0;}}"], function (props) {
  return props.height - 10;
});
var ListItem = exports.ListItem = function ListItem(props) {
  var item = props.item,
    isSelected = props.isSelected,
    theme = props.theme,
    getKey = props.getKey,
    renderItemText = props.renderItemText,
    renderItemDescription = props.renderItemDescription,
    renderItemLabel = props.renderItemLabel,
    onItemSelect = props.onItemSelect,
    _props$virtualScrollP = props.virtualScrollProps,
    virtualScrollProps = _props$virtualScrollP === void 0 ? {
      itemSize: 31
    } : _props$virtualScrollP,
    itemComponent = props.itemComponent;
  var itemSize = virtualScrollProps.itemSize;
  var headerStyle = {
    margin: 0,
    fontWeight: theme ? theme.fontWeightHeavy : 600,
    fontSize: theme ? theme.fontSizeLarge : "18px"
  };
  var hasDescription = function hasDescription(item) {
    if (typeof renderItemDescription === "function") {
      if (!!item.element.props.description) {
        return "true";
      }
    }
    return "false";
  };
  var Item = itemComponent || BPMenuItem;
  return /*#__PURE__*/_react["default"].createElement(Item, {
    key: getKey(item),
    "data-testid": getKey(item),
    icon: isSelected ? _icons.IconNames.TICK : _icons.IconNames.BLANK,
    hasdescription: hasDescription(item),
    text: typeof renderItemDescription === "function" ? /*#__PURE__*/_react["default"].createElement(FlexContainer, {
      height: itemSize
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      style: headerStyle
    }, renderItemText(item)), renderItemDescription(item)) : renderItemText(item),
    label: renderItemLabel && /*#__PURE__*/_react["default"].createElement("small", null, renderItemLabel(item)),
    onClick: function onClick() {
      return onItemSelect(item);
    }
  });
};